import React from "react";

const VIDEO_URL =
  "https://www.loom.com/embed/4a10b9b1620043e48006b0a587356068";

const EndToEndJourneySlide = () => {
  return (
    <div className="h-full w-full bg-black relative overflow-hidden">
      <iframe
        src={VIDEO_URL}
        title="The End-to-End Patient Journey on the Asha AI Operating System"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
};

export default EndToEndJourneySlide;
